export const formatDateToShortMonth = ({
  day,
  month,
  year,
}: {
  day: number;
  month: number;
  year: number;
}): string => {
  const date = new Date(year, month - 1, day);
  const shortMonth = date.toLocaleString("en-US", { month: "short" });

  return `${day} ${shortMonth}`;
};
